module.exports = __webpack_public_path__ + "img/broatcast-step1.947052bc.png";